import { createAction, createStandardAction } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import { Folders } from '@chegg-wt/core/types/folders'
import { ActionTypes } from './constants'
import {
  AddFolderPayload,
  CreateProjectsPayload,
  EditFolderPayload,
  MoveProjectsPayload,
  RemoveFolderPayload,
} from './types'

export const setFolders = createStandardAction(ActionTypes.SET_FOLDERS)<Folders>()

export const fetchAllFolders = createStandardAction(ActionTypes.FETCH_ALL_FOLDERS)()

export const fetchFoldersError = createErrorAction(ActionTypes.FETCH_FOLDERS_ERROR)

export const setFolderId = createAction(ActionTypes.SET_FOLDERS_ID, (action) => {
  return (id: number) => action({ id })
})

export const fetchFolderProjects = createAction(
  ActionTypes.FETCH_FOLDER_PROJECTS,
  (action) => {
    return (folderId: number) => action({ folderId })
  }
)

export const moveProjects = createStandardAction(
  ActionTypes.MOVE_PROJECTS_REQUEST
)<MoveProjectsPayload>()

export const addFolder = createStandardAction(
  ActionTypes.ADD_FOLDERS_REQUEST
)<AddFolderPayload>()
export const addFolderFailed = createErrorAction(ActionTypes.ADD_FOLDERS_ERROR)

export const editFolder = createStandardAction(
  ActionTypes.EDIT_FOLDERS_REQUEST
)<EditFolderPayload>()
export const editFolderFailed = createErrorAction(ActionTypes.EDIT_FOLDERS_ERROR)

export const createCiteProject = createStandardAction(
  ActionTypes.CREATE_PROJECT
)<CreateProjectsPayload>()
export const createCiteProjectSuccess = createStandardAction(
  ActionTypes.CREATE_PROJECT_SUCCESS
)()
export const createCiteProjectError = createErrorAction(ActionTypes.CREATE_PROJECT_ERROR)

export const deleteCiteProjectError = createErrorAction(ActionTypes.DELETE_PROJECT_ERROR)

export const removeFolder = createStandardAction(
  ActionTypes.REMOVE_FOLDERS_REQUEST
)<RemoveFolderPayload>()

export const removeFoldersFailed = createErrorAction(ActionTypes.REMOVE_FOLDERS_ERROR)
